import {
    AI_COMMUNITY_TAB_LIST,
    SUPPORT_COMMUNITY_APP_TYPE,
    WORK_TYPE_TO_TOOL_PAGE_PATH,
    AI_COMMUNITY_TYPES,
    PUBLISH_TYPE,
} from '../../config/dataConfig/FJCommunityData';
import FJAppConstant from '../../constants/FJAppConstant';
import FJConstant from '../../constants/FJConstant';
import FJLocalStore from '../../store/FJLocalStore';
import FJUtil from '../../util/FJUtil';
import {
    initialIsLoadedPage,
    setSliceAdvertisingList,
    setSliceEntirePageLoading,
    setSliceCommunityList,
    setSliceCommunityPageInfo,
    setSliceCommunityTypes,
    setSliceCurCommunityCategory,
    setSliceCurCommunityType,
    setSliceGuestUserInfo,
    setSliceHomeList,
    setSliceHomePageInfo,
    setSliceIsLoadedPage,
    setSliceLikedCreationsList,
    setSliceLikedCreationsPageInfo,
    setSliceMultipleSelectedList,
    setSliceMyCreationsDetailInfo,
    setSliceMyCreationsDetailList,
    setSliceMyCreationsDetailPageInfo,
    setSliceMyCreationsList,
    setSliceMyCreationsPageLoading,
    setSliceMyCreationsPageScene,
    setSliceMySpaceTabType,
    setSliceNavBarTab,
    setSliceSharedCreationsList,
    setSliceSharedCreationsPageInfo,
    setSliceUserInfo,
    setSliceCurCommunitySortType,
} from '../slices/FJSliceCommunity';
import FJCommunityStore from '../../store/FJCommunityStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJConfig from '../../config/FJConfig';
import { sha256 } from 'js-sha256';
import FJActionModal from './FJActionModal';
import FJCommunityUtil from '../../util/FJCommunityUtil';
const isRelease = FJConfig.isRelease;
import FJActionCommon from './FJActionCommon';

const _getFileName = () => {
    const now = new Date();
    // 获取年、月、日、时、分、秒
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
    const day = String(now.getDate()).padStart(2, '0'); // 补零
    const hours = String(now.getHours()).padStart(2, '0'); // 补零
    const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
    const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

    // 格式化日期和时间为 2024-07-17T111525
    return `Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}`;
};
const FJActionCommunity = {
    initAdvertisingListAction: function () {
        return async dispatch => {
            const list = await FJCommunityStore.getAdvertisingList();
            if (!list) return;
            dispatch(setSliceAdvertisingList(list));
        };
    },
    initNavBarAction: function () {
        return async dispatch => {
            let href = isRelease ? '/ai/' : '/apply/';
            const removeLocalStringPath = FJUtil.getRemoveLocalString();
            const matchPath = removeLocalStringPath.replace(href, '');
            const defaultTab = AI_COMMUNITY_TAB_LIST.find(
                item => item.hrefSuffix && matchPath.includes(item.hrefSuffix),
            )?.value;
            let page = 'home';
            let path = matchPath.split('/').shift();
            let userKey = matchPath.split('/').pop();
            if (path === 'space' || path === 'tools' || path === 'community') {
                userKey = '';
            }
            if (defaultTab === FJConstant.HOME && userKey) {
                if (FJCommunityUtil.getUserKey() === userKey) {
                    dispatch(
                        setSliceGuestUserInfo({
                            avatar: '',
                            username: '',
                            likeNum: 0,
                            userKey: '',
                            guestMode: false,
                        }),
                    );
                    dispatch(FJActionCommunity.changeNavBarTabAction(FJConstant.MY_SPACE, { ignoreTitle: true }));
                    dispatch(setSliceMySpaceTabType(FJConstant.SHARED_CREATIONS));
                    page = 'my space';
                } else {
                    const info = await FJCommunityStore.getUserInfo(userKey);
                    if (info) {
                        dispatch(
                            setSliceGuestUserInfo({
                                avatar: info.avatar,
                                username: info.username,
                                likeNum: info.like_num,
                                userKey: userKey,
                                guestMode: FJCommunityUtil.getUserKey() !== userKey,
                            }),
                        );
                        dispatch(setSliceNavBarTab(FJConstant.MY_SPACE));
                        dispatch(setSliceMySpaceTabType(FJConstant.SHARED_CREATIONS));
                        document.title = info.username;
                        page = 'my space';
                    } else {
                        dispatch(FJActionCommunity.changeNavBarTabAction(FJConstant.HOME, { ignoreTitle: true }));
                        page = 'home';
                    }
                }
            } else if (defaultTab && FJUtil.isLogin()) {
                dispatch(FJActionCommunity.changeNavBarTabAction(defaultTab, { ignoreTitle: true }));
                switch (defaultTab) {
                    case FJConstant.HOME:
                        page = 'home';
                        break;
                    case FJConstant.COMMUNITY:
                        page = 'community';
                        break;
                    case FJConstant.AI_TOOL_LIST:
                        page = 'ai tools';
                        break;
                    case FJConstant.MY_SPACE:
                        page = 'my space';
                        break;
                }
            } else {
                dispatch(FJActionCommunity.changeNavBarTabAction(FJConstant.HOME, { ignoreTitle: true }));
                page = 'home';
            }
            FJUtil.eaLog('ai home visit', {
                page,
            });
            dispatch(setSliceEntirePageLoading(false));
        };
    },
    changeNavBarTabAction: function (tab, options = {}) {
        return (dispatch, getState) => {
            const { ignoreTitle = false } = options;
            const { guestUserInfo } = getState().community;
            if (tab === FJConstant.MY_SPACE && !FJUtil.isLogin() && !guestUserInfo.guestMode) {
                FJUtil.login(() => {});
                return;
            }
            dispatch(setSliceNavBarTab(tab));

            if (!FJUtil.isSpecialPage() && !ignoreTitle) {
                const tag = FJLocalStore.currentTag();
                let linkTag = tag === 'en' ? `` : `/${tag}`;
                const { origin, search } = window.location;

                let href = isRelease ? '/ai/' : '/apply/';
                let title = '';
                switch (tab) {
                    case FJConstant.HOME:
                        href += 'home/';
                        title = 'ai-home';

                        break;
                    case FJConstant.COMMUNITY:
                        href += 'community/';
                        title = 'ai-community';
                        break;
                    case FJConstant.AI_TOOL_LIST:
                        href += 'tools/';
                        title = 'ai-tools';
                        break;
                    case FJConstant.MY_SPACE:
                        href += 'space/';
                        title = 'ai-space';

                        break;
                    default:
                        break;
                }
                FJUtil.changeLocation(`${origin}${linkTag}${href}${search}`);
                document.title = FJLocalStore._(title) + ' | FlexClip';
            }
        };
    },
    changeMySpaceTabTypeAction: function (value) {
        return async dispatch => {
            dispatch(setSliceMySpaceTabType(value));
        };
    },
    initCommunityTypesAction: function () {
        return async (dispatch, getState) => {
            const { appType } = getState().common;
            const data = await FJCommunityStore.getCommunityTypes();
            if (!data) {
                return;
            }
            dispatch(setSliceCommunityTypes(data));
            let curCommunityType = '';
            if (appType === FJAppConstant.AI_COMMUNITY) {
                curCommunityType = AI_COMMUNITY_TYPES.TREND;
            } else if (
                appType === FJAppConstant.IMAGE_TO_IMAGE ||
                appType === FJAppConstant.AI_PHOTO_EDITOR ||
                appType === FJAppConstant.TEXT_TO_IMAGE
            ) {
                curCommunityType = AI_COMMUNITY_TYPES.IMAGES;
            } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                curCommunityType = AI_COMMUNITY_TYPES.VIDEO;
            }
            dispatch(this.changeCommunityTypeAction(curCommunityType));
        };
    },
    _initListAction: function (pageInfo, setPageInfo, getList, setList, isUpdate = false) {
        return async dispatch => {
            !isUpdate && dispatch(setPageInfo({ ...pageInfo, initLoading: true }));
            const { list, hasMore } = await getList();
            if (!list) {
                // !isUpdate && dispatch(setPageInfo({ ...pageInfo, initLoading: false }));
                return;
            }
            const start = pageInfo.limit + 1;
            const total = list.length;
            dispatch(setPageInfo({ ...pageInfo, hasMore, start, total, initLoading: false }));
            dispatch(setList(list.filter(item => !!item)));
        };
    },
    _getMoreListAction: function (pageInfo, setPageInfo, preList, getList, setList) {
        return async dispatch => {
            if (pageInfo.getMoreLoading || !pageInfo.hasMore || pageInfo.initLoading) {
                return;
            }
            dispatch(setPageInfo({ ...pageInfo, getMoreLoading: true }));
            const { list, hasMore } = await getList();
            if (!list) {
                dispatch(setPageInfo({ ...pageInfo, getMoreLoading: false }));
                return;
            }
            const start = pageInfo.start + pageInfo.limit;
            const total = pageInfo.total + list.length;
            dispatch(setPageInfo({ ...pageInfo, hasMore, start, total, getMoreLoading: false }));
            dispatch(setList([...preList, ...list.filter(item => !!item)]));
        };
    },
    initHomeListAction: function (isUpdate = false) {
        return async (dispatch, getState) => {
            let { homePageInfo } = getState().community;
            const getList = async () => {
                return await FJCommunityStore.getCommunityList({
                    start: 1,
                    limit: homePageInfo.limit,
                    workType: FJConstant.HOME_WORK,
                    userKey: FJCommunityUtil.getUserKey(),
                });
            };
            await dispatch(
                FJActionCommunity._initListAction(
                    homePageInfo,
                    setSliceHomePageInfo,
                    getList,
                    setSliceHomeList,
                    isUpdate,
                ),
            );
        };
    },

    getMoreHomeListAction: function () {
        return async (dispatch, getState) => {
            let { homePageInfo, homeList } = getState().community;
            const getList = async () => {
                return await FJCommunityStore.getCommunityList({
                    start: homePageInfo.start,
                    limit: homePageInfo.limit,
                    workType: FJConstant.HOME_WORK,
                    userKey: FJCommunityUtil.getUserKey(),
                });
            };
            await dispatch(
                FJActionCommunity._getMoreListAction(
                    homePageInfo,
                    setSliceHomePageInfo,
                    homeList,
                    getList,
                    setSliceHomeList,
                ),
            );
        };
    },

    initCommunityListAction: function (isUpdate = false) {
        return async (dispatch, getState) => {
            if (!getState().community.communityTypes.length) {
                await dispatch(FJActionCommunity.initCommunityTypesAction());
            }

            let { communityPageInfo, curCommunityType, curCommunityCategory, curCommunitySortType } =
                getState().community;

            const getList = async () => {
                return await FJCommunityStore.getCommunityList({
                    start: 1,
                    limit: communityPageInfo.limit,
                    type: curCommunityType,
                    category: curCommunityCategory,
                    workType: FJConstant.COMMUNITY_WORK,
                    userKey: FJCommunityUtil.getUserKey(),
                    sortType: curCommunitySortType,
                });
            };
            await dispatch(
                FJActionCommunity._initListAction(
                    communityPageInfo,
                    setSliceCommunityPageInfo,
                    getList,
                    setSliceCommunityList,
                    isUpdate,
                ),
            );
        };
    },

    getMoreCommunityListAction: function () {
        return async (dispatch, getState) => {
            let { communityPageInfo, curCommunityType, curCommunityCategory, communityList, curCommunitySortType } =
                getState().community;
            const getList = async () => {
                return await FJCommunityStore.getCommunityList({
                    start: communityPageInfo.start,
                    limit: communityPageInfo.limit,
                    type: curCommunityType,
                    category: curCommunityCategory,
                    workType: FJConstant.COMMUNITY_WORK,
                    userKey: FJCommunityUtil.getUserKey(),
                    sortType: curCommunitySortType,
                });
            };
            await dispatch(
                FJActionCommunity._getMoreListAction(
                    communityPageInfo,
                    setSliceCommunityPageInfo,
                    communityList,
                    getList,
                    setSliceCommunityList,
                ),
            );
        };
    },
    initMyCreationsListAction: function (isUpdate = false) {
        return async dispatch => {
            !isUpdate && dispatch(setSliceMyCreationsPageLoading(true));
            const list = await FJCommunityStore.getMyCreationsList();
            if (!list) {
                !isUpdate && dispatch(setSliceMyCreationsPageLoading(false));
                return;
            }
            !isUpdate && dispatch(setSliceMyCreationsPageLoading(false));
            dispatch(setSliceMyCreationsList(list));
        };
    },
    getMyCreationsDetailListAction: function (collection, isUpdate = false) {
        return async (dispatch, getState) => {
            let { myCreationsDetailPageInfo } = getState().community;
            dispatch(setSliceMyCreationsPageScene(FJConstant.DETAIL));
            if (collection) {
                dispatch(
                    setSliceMyCreationsDetailInfo({
                        categoryName: collection.category,
                        toolKey: collection.toolKey,
                    }),
                );
            }
            const getList = async () => {
                return await FJCommunityStore.getMyCreationsDetailList(collection.toolKey, {
                    page: 1,
                    pageSize: myCreationsDetailPageInfo.limit,
                });
            };
            await dispatch(
                FJActionCommunity._initListAction(
                    myCreationsDetailPageInfo,
                    setSliceMyCreationsDetailPageInfo,
                    getList,
                    setSliceMyCreationsDetailList,
                    isUpdate,
                ),
            );
        };
    },
    getMoreMyCreationsDetailListAction: function () {
        return async (dispatch, getState) => {
            let { myCreationsDetailPageInfo, myCreationsDetailList, myCreationsDetailInfo } = getState().community;
            const page = Math.ceil(myCreationsDetailPageInfo.start / myCreationsDetailPageInfo.limit);
            const getList = async () => {
                return await FJCommunityStore.getMyCreationsDetailList(myCreationsDetailInfo.toolKey, {
                    page,
                    pageSize: myCreationsDetailPageInfo.limit,
                });
            };
            await dispatch(
                FJActionCommunity._getMoreListAction(
                    myCreationsDetailPageInfo,
                    setSliceMyCreationsDetailPageInfo,
                    myCreationsDetailList,
                    getList,
                    setSliceMyCreationsDetailList,
                ),
            );
        };
    },
    initSharedCreationsListAction: function (isUpdate = false) {
        return async (dispatch, getState) => {
            let { sharedCreationsPageInfo, guestUserInfo } = getState().community;
            const getList = async () => {
                return await FJCommunityStore.getSharedCreationsList({
                    start: 1,
                    limit: sharedCreationsPageInfo.limit,
                    userKey: !guestUserInfo.guestMode ? FJCommunityUtil.getUserKey() : guestUserInfo.userKey,
                });
            };
            await dispatch(
                FJActionCommunity._initListAction(
                    sharedCreationsPageInfo,
                    setSliceSharedCreationsPageInfo,
                    getList,
                    setSliceSharedCreationsList,
                    isUpdate,
                ),
            );
        };
    },
    getMoreSharedCreationsListAction: function () {
        return async (dispatch, getState) => {
            let { sharedCreationsPageInfo, sharedCreationsList, guestUserInfo } = getState().community;
            const getList = async () => {
                return await FJCommunityStore.getSharedCreationsList({
                    start: sharedCreationsPageInfo.start,
                    limit: sharedCreationsPageInfo.limit,
                    userKey: !guestUserInfo.guestMode ? '' : guestUserInfo.userKey,
                });
            };
            await dispatch(
                FJActionCommunity._getMoreListAction(
                    sharedCreationsPageInfo,
                    setSliceSharedCreationsPageInfo,
                    sharedCreationsList,
                    getList,
                    setSliceSharedCreationsList,
                ),
            );
        };
    },
    initLikedCreationsListAction: function (isUpdate = false) {
        return async (dispatch, getState) => {
            let { likedCreationsPageInfo } = getState().community;
            const getList = async () => {
                return await FJCommunityStore.getMyLikeList({
                    start: 1,
                    limit: likedCreationsPageInfo.limit,
                });
            };
            await dispatch(
                FJActionCommunity._initListAction(
                    likedCreationsPageInfo,
                    setSliceLikedCreationsPageInfo,
                    getList,
                    setSliceLikedCreationsList,
                    isUpdate,
                ),
            );
        };
    },
    getMoreLikedCreationsListAction: function () {
        return async (dispatch, getState) => {
            let { likedCreationsPageInfo, likedCreationsList } = getState().community;
            const getList = async () => {
                return await FJCommunityStore.getMyLikeList({
                    start: likedCreationsPageInfo.start,
                    limit: likedCreationsPageInfo.limit,
                });
            };
            await dispatch(
                FJActionCommunity._getMoreListAction(
                    likedCreationsPageInfo,
                    setSliceLikedCreationsPageInfo,
                    likedCreationsList,
                    getList,
                    setSliceLikedCreationsList,
                ),
            );
        };
    },
    changeCommunityTypeAction: function (type) {
        return async (dispatch, getState) => {
            const { navBarTab, communityTypes } = getState().community;
            const { appType } = getState().common;
            dispatch(setSliceCurCommunityType(type));
            const curType = communityTypes.find(item => item.type === type);
            const curCategory = curType?.list?.[0]?.type || '';
            dispatch(setSliceCurCommunityCategory(curCategory));
            dispatch(FJActionCommunity.initCommunityListAction());
            FJUtil.eaLog('ai community visit', {
                category: type,
                'ai page': FJCommunityUtil.getCommunityPageName({ appType, communityNavBarTab: navBarTab }),
            });
        };
    },
    changeCategoryTypeAction: function (type) {
        return async dispatch => {
            dispatch(setSliceCurCommunityCategory(type));
            dispatch(FJActionCommunity.initCommunityListAction());
        };
    },
    changeSortTypeAction: function (type) {
        return async dispatch => {
            dispatch(setSliceCurCommunitySortType(type));
            dispatch(FJActionCommunity.initCommunityListAction());
        };
    },

    onRecreateClickAction: function (item, isPreview = false) {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            const { navBarTab } = getState().community;
            const { jobType, communityId } = item;
            const aiPath = FJConfig.isRelease ? '/ai' : '/apply';
            const baseUrl = `${aiPath}${WORK_TYPE_TO_TOOL_PAGE_PATH[jobType]}`;
            const _isCurrentPage = () => {
                const photoGenerateJobType = [3, 6, 36];
                const photoGenerateAppType = [
                    FJAppConstant.AI_PHOTO_EDITOR,
                    FJAppConstant.TEXT_TO_IMAGE,
                    FJAppConstant.IMAGE_TO_IMAGE,
                ];
                const videoGeneratorJobType = [14, 28];
                const videoGeneratorAppType = [FJAppConstant.AI_VIDEO_GENERATOR, FJAppConstant.AI_VIDEO_EFFECT];
                if (photoGenerateJobType.includes(jobType) && photoGenerateAppType.includes(appType)) {
                    return true;
                }
                if (videoGeneratorJobType.includes(jobType) && videoGeneratorAppType.includes(appType)) {
                    return true;
                }
                return false;
            };
            const data = { ...item, fromType: FJConstant.COMMUNITY };
            if (SUPPORT_COMMUNITY_APP_TYPE.includes(appType) && _isCurrentPage()) {
                dispatch(FJActionModal.hideDetailsPreviewModalDataAction());
                dispatch(FJActionCommon.onRecreateAction(data));
            } else if (data) {
                const rec_id = sha256(JSON.stringify(data));
                localStorage.setItem(rec_id, JSON.stringify(data));
                window.open(`${baseUrl}?rec_id=${rec_id}`, '_blank');
            }
            FJUtil.eaLog('ai community ai recreate click', {
                'ai page': FJCommunityUtil.getCommunityPageName({ appType, communityNavBarTab: navBarTab }),
                location: isPreview ? 'preview' : 'hover',
            });
            communityId && FJCommunityUtil.addCommunityBehavior([communityId], 4);
        };
    },

    onLikeClickAction: function (item, newIsLike, options = {}) {
        return async (dispatch, getState) => {
            const { callback, isPreview = false } = options;
            const appType = getState().common.appType;
            const { communityList, homeList, likedCreationsList, sharedCreationsList, navBarTab } =
                getState().community;
            FJUtil.eaLog('ai community like click', {
                'ai page': FJCommunityUtil.getCommunityPageName({ appType, communityNavBarTab: navBarTab }),
                location: isPreview ? 'preview' : 'cover',
            });
            if (!FJUtil.isLogin()) {
                FJUtil.login(() => {});
                return;
            }

            const { communityId, workType, id, isLike: oldIsLike, likeNum: oldLikeNum } = item;
            const newNumber = newIsLike ? oldLikeNum + 1 : oldLikeNum - 1;
            const __updateNewLikedList = (isLike, number) => {
                let newList = [];

                switch (workType) {
                    case FJConstant.COMMUNITY_WORK:
                        newList = communityList;
                        break;
                    case FJConstant.HOME_WORK:
                        newList = homeList;
                        break;
                    case FJConstant.SHARED_WORK:
                        newList = sharedCreationsList;
                        break;
                    case FJConstant.LIKE_WORK:
                        newList = likedCreationsList;
                        break;
                    default:
                        break;
                }
                newList = newList.map(i => (i.id === id ? { ...i, isLike, likeNum: number } : i));
                switch (workType) {
                    case FJConstant.COMMUNITY_WORK:
                        dispatch(setSliceCommunityList(newList));
                        break;
                    case FJConstant.HOME_WORK:
                        dispatch(setSliceHomeList(newList));
                        break;
                    case FJConstant.SHARED_WORK:
                        dispatch(setSliceSharedCreationsList(newList));
                        break;
                    case FJConstant.LIKE_WORK:
                        dispatch(setSliceLikedCreationsList(newList));
                        break;
                    default:
                        break;
                }
            };
            __updateNewLikedList(newIsLike, newNumber);
            const res = await FJCommunityStore.setLike(id, newIsLike);
            if (!res) {
                const text = newIsLike
                    ? FJLocalStore._('could-not-like-this-creation')
                    : FJLocalStore._('could-not-remove-your-like');
                FJMessageStore.addMessage(FJLocalStore._(text), 'error');
                callback && callback(false);
                __updateNewLikedList(oldIsLike, oldLikeNum);
                return;
            }
            callback && callback(true);
            dispatch(FJActionCommunity.updateLikeAction(item, newIsLike, newNumber));
            communityId && newIsLike && FJCommunityUtil.addCommunityBehavior([communityId], 2);
        };
    },
    updateLikeAction: function (item, newIsLike, newNumber) {
        return async (dispatch, getState) => {
            const {
                communityList,
                homeList,
                myCreationsList,
                myCreationsDetailList,
                likedCreationsList,
                sharedCreationsList,
                isLoadedPage,
                likedCreationsPageInfo,
            } = getState().community;
            const __updateNormalList = (list, isLoaded, setList) => {
                if (isLoaded) {
                    let needUpdate = false;
                    const newList = list.map(i => {
                        if (i.id === item.id) {
                            needUpdate = true;
                            return { ...i, isLike: newIsLike, likeNum: newNumber };
                        }
                        return i;
                    });
                    if (needUpdate) {
                        dispatch(setList(newList));
                    }
                }
            };
            const __updateMyCreationsList = (list, isLoaded, setList) => {
                if (isLoaded) {
                    let needUpdate = false;
                    const newList = list.map(category => ({
                        ...category,
                        list: category.list.map(i => {
                            if (i.id === item.id) {
                                needUpdate = true;
                                return { ...i, isLike: newIsLike, likeNum: newNumber };
                            }
                            return i;
                        }),
                    }));
                    if (needUpdate) {
                        dispatch(setList(newList));
                    }
                }
            };
            __updateNormalList(communityList, isLoadedPage.community, setSliceCommunityList);
            __updateNormalList(homeList, isLoadedPage.home, setSliceHomeList);
            __updateNormalList(sharedCreationsList, isLoadedPage.sharedCreations, setSliceSharedCreationsList);
            __updateNormalList(myCreationsDetailList, isLoadedPage.myCreationsDetail, setSliceMyCreationsDetailList);
            __updateMyCreationsList(myCreationsList, isLoadedPage.myCreations, setSliceMyCreationsList);
            if (isLoadedPage.likedCreations) {
                if (newIsLike) {
                    dispatch(FJActionCommunity.initLikedCreationsListAction(true));
                } else {
                    dispatch(
                        this.__deleteListAction([item.id], likedCreationsList, {
                            isLoaded: isLoadedPage.likedCreations,
                            setList: setSliceLikedCreationsList,
                            pageInfo: likedCreationsPageInfo,
                            setPageInfo: setSliceLikedCreationsPageInfo,
                        }),
                    );
                }
            }
        };
    },

    updatePrivacySettingAction: function (ids, privacyStatus) {
        return async (dispatch, getState) => {
            if (!ids?.length) return;
            const __updateNormalList = (list, isLoaded, setList) => {
                if (isLoaded) {
                    let needUpdate = false;
                    const newList = list.map(i => {
                        if (ids.includes(i.id)) {
                            needUpdate = true;
                            return { ...i, privacyStatus };
                        }
                        return i;
                    });
                    if (needUpdate) {
                        dispatch(setList(newList));
                    }
                }
            };
            const __updateMyCreationsList = (list, isLoaded, setList) => {
                if (isLoaded) {
                    let needUpdate = false;
                    const newList = list.map(category => ({
                        ...category,
                        list: category.list.map(i => {
                            if (ids.includes(i.id)) {
                                needUpdate = true;
                                return { ...i, privacyStatus };
                            }
                            return i;
                        }),
                    }));
                    if (needUpdate) {
                        dispatch(setList(newList));
                    }
                }
            };
            const {
                sharedCreationsList,
                myCreationsList,
                sharedCreationsPageInfo,
                isLoadedPage,
                // homePageInfo,
                // homeList,
                // communityPageInfo,
                // communityList,
                myCreationsDetailList,
                myCreationsPageScene,
            } = getState().community;
            if (privacyStatus === PUBLISH_TYPE.PUBLIC && isLoadedPage.sharedCreations) {
                // 添加sharedCreationsList列表
                dispatch(FJActionCommunity.initSharedCreationsListAction(true));
            } else if (isLoadedPage.sharedCreations) {
                // 删除sharedCreationsList列表
                const newSharedCreationsList = sharedCreationsList
                    .map(i => (ids.includes(i.id) ? { ...i, privacyStatus } : i))
                    .filter(i => i.privacyStatus === PUBLISH_TYPE.PUBLIC);
                let newPageInfo = { ...sharedCreationsPageInfo };
                const needUpdate = sharedCreationsList.length !== newSharedCreationsList.length;
                newPageInfo.start = Math.max(
                    1,
                    newPageInfo.start - (sharedCreationsList.length - newSharedCreationsList.length),
                );
                newPageInfo.total = newPageInfo.total - (sharedCreationsList.length - newSharedCreationsList.length);
                if (needUpdate) {
                    dispatch(setSliceSharedCreationsList(newSharedCreationsList));
                    dispatch(setSliceSharedCreationsPageInfo(newPageInfo));
                }
            }

            __updateMyCreationsList(myCreationsList, isLoadedPage.myCreations, setSliceMyCreationsList);
            __updateNormalList(
                myCreationsDetailList,
                myCreationsPageScene === FJConstant.DETAIL,
                setSliceMyCreationsDetailList,
            );
        };
    },
    initUserInfoAction: function () {
        return async dispatch => {
            const myUserKey = FJCommunityUtil.getUserKey();
            const userInfo = await FJCommunityStore.getUserInfo(myUserKey);
            if (!userInfo) {
                return;
            }
            dispatch(
                setSliceUserInfo({
                    avatar: userInfo.avatar,
                    username: userInfo.username,
                    likeNum: userInfo.like_num,
                }),
            );
        };
    },
    onPreviewClickAction: function (item) {
        return async (dispatch, getState) => {
            const { workType } = item;
            const {
                homeList,
                communityList,
                myCreationsList,
                myCreationsDetailList,
                sharedCreationsList,
                likedCreationsList,
            } = getState().community;
            let previewList = [];
            const _getCategoryList = () => {
                const category = myCreationsList.find(categoryInfo => categoryInfo.list.find(i => i.id === item.id));
                if (category) {
                    return category.list;
                }
                return [];
            };
            switch (workType) {
                case FJConstant.HOME_WORK:
                    previewList = homeList;
                    break;
                case FJConstant.COMMUNITY_WORK:
                    previewList = communityList;
                    break;
                case FJConstant.MY_CREATIONS_WORK:
                    previewList = _getCategoryList();
                    break;
                case FJConstant.MY_CREATIONS_DETAIL_WORK:
                    previewList = myCreationsDetailList;
                    break;
                case FJConstant.SHARED_WORK:
                    previewList = sharedCreationsList;
                    break;
                case FJConstant.LIKE_WORK:
                    previewList = likedCreationsList;
                    break;

                default:
                    break;
            }
            if (item.isSupportCommunity) {
                dispatch(FJActionModal.showDetailsPreviewModalDataAction({ data: { ...item, previewList } }));
            } else {
                dispatch(
                    FJActionModal.showPreviewModalDataAction({
                        data: { ...item, previewList, type: FJConstant.HISTORY },
                    }),
                );
            }
            const communityId = item.communityId;
            communityId && FJCommunityUtil.addCommunityBehavior([communityId], 1);
        };
    },

    onShareSettingClickAction: function (workItem, value, callback, options = {}) {
        return async dispatch => {
            const { ignoreMessage = false } = options;
            const { id } = workItem;

            const res = await FJCommunityStore.publishCommunityWork([id], value);
            if (!res) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-update-privacy-setting'), 'error');
                callback && callback(false);
                return;
            }
            !ignoreMessage && FJMessageStore.addMessage(FJLocalStore._('updated-successfully'));
            callback && callback(true);

            dispatch(FJActionCommunity.updatePrivacySettingAction([id], value));
            FJUtil.eaLog('community privacy settings', {
                setting: value,
            });
        };
    },

    multiDeleteAction: function (ids, callback = () => {}) {
        return async (dispatch, getState) => {
            const multipleSelectedList = getState().community.multipleSelectedList;
            const content =
                ids.length < 2
                    ? FJLocalStore._('project-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue').replace(
                          'xx',
                          ids.length,
                      )
                    : FJLocalStore._(
                          'projects-will-be-deleted-and-cannot-be-restored-are-you-sure-to-continue',
                      ).replace('xx', ids.length);

            const __delete = async () => {
                const __error = () => {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
                    callback(false);
                };
                try {
                    const result = await FJCommunityStore.deleteWork(ids);
                    if (result) {
                        const newSelectList = multipleSelectedList.filter(i => !ids.includes(i));
                        dispatch(setSliceMultipleSelectedList(newSelectList));
                        dispatch(FJActionCommunity._updateDeleteListAction(ids));
                        callback(true);
                    } else {
                        __error();
                    }
                } catch (e) {
                    __error();
                }
            };

            dispatch(
                FJActionModal.showWarningModalAction({
                    title: FJLocalStore._('delete-project'),
                    content: content,
                    footerDates: [
                        {
                            btnType: FJConstant.WARNING,
                            btnText: FJLocalStore._('delete'),
                            btnCallback: async () => {
                                __delete();
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        };
    },
    _updateDeleteListAction: function (ids) {
        return async (dispatch, getState) => {
            const {
                sharedCreationsList,
                homeList,
                communityList,
                myCreationsList,
                myCreationsDetailList,
                sharedCreationsPageInfo,
                homePageInfo,
                communityPageInfo,
                myCreationsDetailPageInfo,
                isLoadedPage,
            } = getState().community;
            dispatch(
                this.__deleteListAction(ids, sharedCreationsList, {
                    isLoaded: isLoadedPage.sharedCreations,
                    setList: setSliceSharedCreationsList,
                    pageInfo: sharedCreationsPageInfo,
                    setPageInfo: setSliceSharedCreationsPageInfo,
                }),
            );
            dispatch(
                this.__deleteListAction(ids, homeList, {
                    isLoaded: isLoadedPage.home,
                    setList: setSliceHomeList,
                    pageInfo: homePageInfo,
                    setPageInfo: setSliceHomePageInfo,
                }),
            );
            dispatch(
                this.__deleteListAction(ids, communityList, {
                    isLoaded: isLoadedPage.community,
                    setList: setSliceCommunityList,
                    pageInfo: communityPageInfo,
                    setPageInfo: setSliceCommunityPageInfo,
                }),
            );

            dispatch(
                this.__deleteListAction(ids, myCreationsDetailList, {
                    isLoaded: isLoadedPage.myCreationsDetail,
                    setList: setSliceMyCreationsDetailList,
                    pageInfo: myCreationsDetailPageInfo,
                    setPageInfo: setSliceMyCreationsDetailPageInfo,
                }),
            );
            if (isLoadedPage.myCreations) {
                let needUpdate = false;
                const newMyCreationsList = myCreationsList
                    .map(category => ({
                        ...category,
                        list: category.list.filter(i => {
                            if (ids.includes(i.id)) {
                                needUpdate = true;
                                return false;
                            }
                            return true;
                        }),
                    }))
                    .filter(category => category.list.length > 0);
                if (needUpdate) {
                    dispatch(setSliceMyCreationsList(newMyCreationsList));
                }
            }
        };
    },
    // myCreationsList 不适用
    __deleteListAction: function (ids, list, { isLoaded, setList, pageInfo, setPageInfo }) {
        return async dispatch => {
            if (!isLoaded || !ids?.length) return;
            let needUpdate = false;
            let newPageInfo = { ...pageInfo };
            let newList = list.filter(i => !ids.includes(i.id));
            needUpdate = list.length !== newList.length;
            newPageInfo.start = Math.max(1, pageInfo.start - (list.length - newList.length));
            newPageInfo.total = pageInfo.total - (list.length - newList.length);
            if (needUpdate) {
                dispatch(setList(newList));
                dispatch(setPageInfo(newPageInfo));
            }
        };
    },

    multiDownloadAction: function (items, callback) {
        return async () => {
            if (!items.length) {
                callback && callback(false);
                return;
            }
            try {
                if (items.length === 1) {
                    const item = items[0];
                    const { videoUrl, imgUrl, mediaType } = item;
                    const isVideo = mediaType === FJConstant.VIDEO || !!videoUrl;
                    const urls = videoUrl ? [videoUrl] : [imgUrl];
                    await FJUtil.multiDownloadByUrls(urls, callback, {
                        isVideo: isVideo,
                    });
                    callback && callback(true);
                } else {
                    let Blobs = [];
                    const folderName = _getFileName();
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        const { videoUrl, imgUrl, mediaType } = item;
                        const isVideo = mediaType === FJConstant.VIDEO || !!videoUrl;
                        let blob;
                        if (isVideo) {
                            blob = await FJUtil.downloadVideoCacheAvoidance(videoUrl);
                            if (!blob) throw new Error();
                            blob.name = _getFileName() + i + '.mp4';
                            Blobs.push(blob);
                        } else {
                            blob = await FJUtil.downloadImageCacheAvoidance(imgUrl);
                            if (!blob) throw new Error();
                            blob.name = _getFileName() + i + '.png';
                            Blobs.push(blob);
                        }
                    }
                    FJUtil.saveBlobsInZip(Blobs, folderName);
                    FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                    callback && callback(true);
                }
            } catch (error) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
                callback && callback(false);
            }
            const communityIds = items.map(item => item.communityId).filter(item => item);
            communityIds.length > 0 && FJCommunityUtil.addCommunityBehavior(communityIds, 5);
        };
    },
    multiVideoEditAction: function (items, callback) {
        return async () => {
            // safari 兼容，safari 不支持异步打开新窗口会被认为是广告而拦截
            // 通过同步方式打开再异步设置 href
            const newTab = window.open('', '_blank');
            try {
                let Blobs = [];
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    const { videoUrl, imgUrl, mediaType } = item;
                    const isVideo = mediaType === FJConstant.VIDEO;
                    let blob;
                    if (isVideo) {
                        blob = await FJUtil.downloadVideoCacheAvoidance(videoUrl);
                        if (!blob) throw new Error();
                        blob.name = _getFileName() + i + '.mp4';
                        Blobs.push(blob);
                    } else {
                        blob = await FJUtil.downloadImageCacheAvoidance(imgUrl);
                        if (!blob) throw new Error();
                        blob.name = _getFileName() + i + '.png';
                        Blobs.push(blob);
                    }
                }

                const _jumpUrl = uploadKey => {
                    const url = FJUtil.getCurrentUrl() + 'editor/app?rec_id=' + uploadKey;
                    // 异步设置 href
                    newTab.location.href = url;
                };
                FJUtil.readFiles(
                    Blobs,
                    {
                        module: 'media',
                    },
                    _jumpUrl,
                );
            } catch (error) {
                console.error(error);
                newTab.close();
                callback && callback(false);
            } finally {
                callback && callback(true);
            }
        };
    },
    multiPrivacySettingChangeAction: function (items, value, callback) {
        return async (dispatch, getState) => {
            const { multipleSelectedList, mySpaceTabType, navBarTab } = getState().community;
            if (!FJUtil.isLogin()) {
                FJUtil.login(() => {});
                return;
            }
            const ids = items.filter(item => item.privacyStatus !== value).map(item => item.id);
            if (ids.length === 0) {
                callback && callback(true);
                return;
            }
            const res = await FJCommunityStore.publishCommunityWork(ids, value);
            if (!res) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-update-privacy-setting'), 'error');
                callback && callback(false);
                return;
            }

            if (mySpaceTabType === FJConstant.SHARED_CREATIONS && navBarTab === FJConstant.MY_SPACE) {
                const newSelectList = multipleSelectedList.filter(i => !ids.includes(i));
                dispatch(setSliceMultipleSelectedList(newSelectList));
            }
            dispatch(FJActionCommunity.updatePrivacySettingAction(ids, value));
            FJMessageStore.addMessage(FJLocalStore._('updated-successfully'));
            FJUtil.eaLog('community privacy settings', {
                setting: value,
            });
            callback && callback(true);
        };
    },
    // updateListAction: function (types = [0, 1, 2]) {
    //     return async (dispatch, getState) => {
    //         const { myCreationsPageScene, myCreationsDetailInfo } = getState().community;
    //         for (const type of types) {
    //             switch (type) {
    //                 case 0:
    //                     dispatch(FJActionCommunity.initMyCreationsListAction(true));
    //                     if (myCreationsPageScene === FJConstant.DETAIL) {
    //                         dispatch(
    //                             FJActionCommunity.getMyCreationsDetailListAction(
    //                                 {
    //                                     toolKey: myCreationsDetailInfo.toolKey,
    //                                     category: myCreationsDetailInfo.categoryName,
    //                                 },
    //                                 true,
    //                             ),
    //                         );
    //                     }
    //                     break;
    //                 case 1:
    //                     dispatch(FJActionCommunity.initSharedCreationsListAction(true));
    //                     break;
    //                 case 2:
    //                     dispatch(FJActionCommunity.initLikedCreationsListAction(true));
    //                     break;
    //             }
    //         }
    //     };
    // },

    loginAfterUpdateAction: function () {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            const { navBarTab } = getState().community;
            dispatch(FJActionCommunity.initUserInfoAction());
            if (appType === FJAppConstant.AI_COMMUNITY) {
                switch (navBarTab) {
                    case FJConstant.HOME:
                        dispatch(FJActionCommunity.initHomeListAction(false));
                        dispatch(setSliceIsLoadedPage({ ...initialIsLoadedPage, home: true }));
                        break;
                    case FJConstant.COMMUNITY:
                        dispatch(FJActionCommunity.initCommunityListAction(false));
                        dispatch(setSliceIsLoadedPage({ ...initialIsLoadedPage, community: true }));
                        break;
                    default:
                        break;
                }
            } else if (SUPPORT_COMMUNITY_APP_TYPE.includes(appType)) {
                dispatch(FJActionCommunity.initCommunityListAction(false));
                dispatch(setSliceIsLoadedPage({ ...initialIsLoadedPage, home: true }));
            }
        };
    },
};

export default FJActionCommunity;
